import React from "react";
import "./personalDetails.css";
import { Modal, ModalBody, Button } from "@americanexpress/dls-react";
import { withTranslation } from "react-i18next";
import Header from "../Header/Header";
import one from "../../assets/progress 1.svg";
import two from "../../assets/disabled progress.svg";
import three from "../../assets/Group 364.svg";
import PersonalDetailsAccordian from "./PersonalDetailsAccordian";
import PersonalDetails from "./newpersonalDetails";
import ErrorIcon from "../../assets/erroricon.svg";
import TickIcon from "../../assets/thankyou.svg";
import crossicon from "../../assets/cross icon.svg";
import Timer from "../Timer/Timer";

class PersonalDetailsContainerComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      minutes: 20,
      seconds: 0,
      ShowAllUsers: false,
      users: [],
      showDeleteConfirm: false,
      userIndx: 0,
      modifyCheckBox: false,
      showCheckBox: false,
    };
  }

  componentDidMount() {
    if (this.props.history.location.state !== undefined) {
      if (this.props.history.location.state[0].length > 1) {
        this.setState({
          prev: true,
          minutes: localStorage.getItem("minutes"),
          seconds: localStorage.getItem("seconds"),
        });
      }

      if (this.props.history.location.pathname === "/modify-user") {
        let users = this.props.history.location.state[0];
        this.setState({ users: users });
      }

      if (
        this.props.history.location.state[0] !== undefined &&
        this.props.history.location.pathname !== "/modify-user"
      ) {
        let users = this.props.history.location.state[0];
        this.setState({ users: users });
      }
    }
  }

  toggleDelete = () =>
    this.setState({ showDeleteConfirm: !this.state.showDeleteConfirm });

  deleteUser = (indx) => {
    this.setState({ showDeleteConfirm: true, userIndx: indx });
  };

  handleDeleteUser = () => {
    let userArr = this.state.users;
    userArr.splice(this.state.userIndx, 1);
    this.setState({ showDeleteConfirm: false });
    this.setState({ users: userArr });
  };

  setUsers = (user, action, modifyCheckBox, showCheckBox, selectedIndex) => {
    const { users } = this.state;
    const [...tempUsers] = users;

    switch (action) {
      case "addNewUser":
        tempUsers.splice(0, 0, user);
        break;
      case "additionalNewUser":
        tempUsers.splice(users.length, 0, user);
        break;
      default:
        tempUsers.splice(selectedIndex, 1, user);
    }
    this.setState({
      users: [...tempUsers],
      action,
      showCheckBox,
      modifyCheckBox,
    });
  };

  shouldComponentUpdate(newprops, newstate) {
    return (
      newstate.users.length !== this.state.users.length ||
      newstate.showDeleteConfirm !== this.state.showDeleteConfirm ||
      newprops.accesses !== this.props.accesses ||
      newstate.action === "modify"
    );
  }

  componentDidUpdate() {
    this.setState({ action: "" });
  }

  render() {
    const { t, history, accesses, modifyUser } = this.props;
    const { users } = this.state;
    return (
      <>
        <Header />
        <div className="userheader">
          <div className="heading">
            <div className="step">
              <div className="step-counter">
                <img src={one} className="stepimg" alt="step1" />{" "}
                <span className="active"> {t("newuser.userdetails")}</span>
              </div>
              <div className="step-counter">
                <img src={two} alt="step2" className="stepimg" />
                <span className="stepper">{t("access.approval")}</span>
              </div>
              <div className="step-counter">
                <img src={three} alt="step3" className="stepimg" />
                <span className="stepper">{t("confirm.confirmdetails")}</span>
              </div>
            </div>
            <div className="timer">
              {this.props.history.location.state !== undefined ? (
                this.props.history.location.state[0].length >= 1 ? (
                  <Timer time={"0"} hist={this.props.history} />
                ) : (
                  <Timer time={"1"} hist={this.props.history} />
                )
              ) : (
                <Timer time={"1"} hist={this.props.history} />
              )}

              {this.state.showDeleteConfirm && (
                <Modal>
                  <ModalBody
                    style={{
                      margin: "80px",
                      paddingTop: "40px",
                      height: "200px",
                    }}
                  >
                    <div className="padResponsiveExtraLr">
                      <img
                        src={ErrorIcon}
                        alt="erroricon"
                        style={{ paddingLeft: "450px" }}
                      />
                      <p style={{ paddingTop: "10px", paddingLeft: "350px" }}>
                        {t("newuser.dodelete")}
                        {1 + parseInt([this.state.userIndx])} -{" "}
                        {this.props.i18n.language === "en"
                          ? `${
                              this.state.users[this.state.userIndx].firstName
                            } ${
                              this.state.users[this.state.userIndx].lastName
                            } ${t("newuser.dodelete2")}`
                          : `${
                              this.state.users[this.state.userIndx].lastName
                            } ${
                              this.state.users[this.state.userIndx].firstName
                            } ${t("newuser.dodelete2")}`}
                      </p>
                    </div>
                    <div style={{ paddingLeft: "300px" }}>
                      <Button
                        style={{ margin: "5px", paddingRight: "15px" }}
                        onClick={this.handleDeleteUser}
                      >
                        <img
                          style={{ paddingRight: "5px" }}
                          src={TickIcon}
                          alt="successicon"
                        />
                        {t("newuser.deleteyes")}
                      </Button>
                      <Button
                        style={{ margin: "5px" }}
                        onClick={this.toggleDelete}
                      >
                        <img
                          style={{ paddingRight: "5px" }}
                          src={crossicon}
                          alt="crossicon"
                        />
                        {t("newuser.deleteno")}
                      </Button>
                    </div>
                  </ModalBody>
                </Modal>
              )}
            </div>
          </div>
        </div>
        {users.length > 0 ? (
          <PersonalDetailsAccordian
            key={Math.random() * 100}
            users={users}
            history={history}
            accesses={accesses}
            modifyUser={modifyUser}
            setShowAllUsers={this.setShowAllUsers}
            setUsers={this.setUsers}
            modifyCheckBox={this.state.modifyCheckBox}
            showCheckBox={this.state.showCheckBox}
            deleteUser={(indx) => this.deleteUser(indx)}
            prev={this.props}
          />
        ) : (
          <PersonalDetails
            key="new"
            selectedIndex={0}
            addNewUser={true}
            history={history}
            accesses={accesses}
            modifyUser={modifyUser}
            setShowAllUsers={this.setShowAllUsers}
            setUsers={this.setUsers}
          />
        )}
      </>
    );
  }
}

export default withTranslation("common")(PersonalDetailsContainerComponent);
